import http from '../utils/http.js'
import md5 from 'js-md5';
export function pageQueryAll(data) {
    return http.get(`/statistics/getStatisticsList`, data)
}